// Code review - In Progress
// Documentation - In Progress

import React, { useEffect, useState } from "react";
import { mainTable } from "../css/Common";
import MainLayout from "../components/MainLayout";
import InputText from "../ReusableComponents/InputText";
import { BindAPI, IUDAPI } from "../services/APIConnection";
import toast from "react-hot-toast";
import Buttons from "../components/Buttons";
import { useNavigate } from "react-router-dom";
const SystemSettings = () => {
  // Use states for input fields
  const [rowsPerPage, setRowsPerPage] = useState("");
  const [systemSettingsId, setSystemSettingsId] = useState("");
  const [sessionTime, setSessionTime] = useState("");
  const [emailId, setEmailId] = useState("");
  const [password, setPassword] = useState("");
  const [sizeForAttachment, setSizeForAttachment] = useState("");
  const [totalAttachmentSize, setTotalAttachmentSize] = useState("");
  const [daysForSubmissionAssessment, setDaysForSubmissionAssessment] =
    useState("");
  const [subscriptionFee, setSubscriptionFee] = useState("");
  const [phone, setPhone] = useState("");
  const [bccMail, setBccMail] = useState("");
  const [ccMail, setCcMail] = useState("");
  const navigate = useNavigate();

  // Use states for error massages
  const [rowsPerPageError, setRowsPerPageError] = useState("");
  const [sessionTimeError, setSessionTimeError] = useState("");
  const [emailIdError, setEmailIdError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [sizeForAttachmentError, setSizeForAttachmentError] = useState("");
  const [totalAttachmentSizeError, setTotalAttachmentSizeError] = useState("");
  const [
    daysForSubmissionAssessmentError,
    setDaysForSubmissionAssessmentError,
  ] = useState("");
  const [subscriptionFeeError, setSubscriptionFeeError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [bccMailError, setBccMailError] = useState("");
  const [ccMailError, setCcMailError] = useState("");
  // validRows for rowsPerPage validation
  const validRows = ["10", "25", "50", "100", "500", "1000", "5000"];

  // bind system setting
  const [bindSystemSettingsData, setBindSystemSettingsData] = useState([]);
  // disable submit button
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);

  // use effect for bind system setting data
  useEffect(() => {
    systemSettingsData();
  }, []);

  const systemSettingsData = async () => {
    const response = await BindAPI("SystemSettingsAPI/BindSystemSettings");

    setBindSystemSettingsData(response.data.Table);
  };

  // use effect for set value
  useEffect(() => {
    systemSettingsBind();
  }, [bindSystemSettingsData]);

  const systemSettingsBind = () => {
    if (bindSystemSettingsData.length > 0) {
      setRowsPerPage(String(bindSystemSettingsData[0].RowsPerPageForTables));
      setSessionTime(bindSystemSettingsData[0].SessionTimeInSeconds);
      setEmailId(bindSystemSettingsData[0].EmailIdForSystemGeneratedEmails);
      setPassword(bindSystemSettingsData[0].PasswordForSystemGeneratedEmails);
      setSizeForAttachment(bindSystemSettingsData[0].SizeForFileAttachment);
      setTotalAttachmentSize(
        bindSystemSettingsData[0].TotalAttachmentFilesForAPartner
      );
      setDaysForSubmissionAssessment(
        bindSystemSettingsData[0].NoOfDaysForSubmissionAssessment
      );
      setSystemSettingsId(bindSystemSettingsData[0].MstSystemSettingsId);
      setSubscriptionFee(bindSystemSettingsData[0].SubscriptionFee);
      setPhone(bindSystemSettingsData[0].Phone);
      setCcMail(bindSystemSettingsData[0].CC);
      setBccMail(bindSystemSettingsData[0].BCC);
    }
  };
  // cancel funtionality
  const Cancel = () => {
    setRowsPerPage("");
    setSessionTime("");
    setEmailId("");
    setPassword("");
    setSizeForAttachment("");
    setTotalAttachmentSize("");
    setDaysForSubmissionAssessment("");
    setSystemSettingsId("");
    setRowsPerPageError("");
    setSessionTimeError("");
    setEmailIdError("");
    setPasswordError("");
    setSizeForAttachmentError("");
    setTotalAttachmentSizeError("");
    setDaysForSubmissionAssessmentError("");
    systemSettingsData();
    setSubmitBtnDisabled(false);

    navigate("/dashboard");
  };
  // submit funtionality
  const HandleSubmit = async (items, flag) => {
    setSubmitBtnDisabled(true);
    // validation start
    let rowsPerPageValidate = "";
    let sessionTimeValidate = "";
    let emailIdValidate = "";
    let passwordValidate = "";
    let sizeForAttachmentValidate = "";
    let totalAttachmentSizeValidate = "";
    let daysForSubmissionAssessmentValidate = "";
    let subscriptionFeeValidate = "";
    let phoneValidate = "";
    // let ccMailValidate = "";
    // let bccMailValidate = "";

    const allowedValues = ["10", "25", "50", "100", "500", "1000", "5000"];

    rowsPerPageValidate =
      rowsPerPage === ""
        ? "Enter Rows Per Page For Tables"
        : !allowedValues.includes(rowsPerPage)
          ? "Please enter a valid value (10, 25, 50, 100, 500, 1000, or 5000)"
          : "";
    setRowsPerPageError(rowsPerPageValidate);

    sessionTimeValidate =
      sessionTime.length === 0
        ? "Enter Session Time in Seconds"
        : /^\d+$/.test(sessionTime)
          ? ""
          : "Please enter a valid number";
    setSessionTimeError(sessionTimeValidate);

    emailIdValidate =
      emailId.length === 0
        ? "Enter Email Id"
        : /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i.test(emailId)
          ? ""
          : "Enter Valid Email Id";

    setEmailIdError(emailIdValidate);

    passwordValidate = password.length === 0 ? "Enter Password" : "";
    setPasswordError(passwordValidate);

    sizeForAttachmentValidate =
      sizeForAttachment.length === 0
        ? "Enter Size For File Attachment"
        : /^\d+$/.test(sizeForAttachment)
          ? ""
          : "Please enter a valid number";
    setSizeForAttachmentError(sizeForAttachmentValidate);

    totalAttachmentSizeValidate =
      totalAttachmentSize.length === 0
        ? "Enter Total Attachment Files For A Partner"
        : /^\d+$/.test(totalAttachmentSize)
          ? ""
          : "Please enter a valid number";
    setTotalAttachmentSizeError(totalAttachmentSizeValidate);

    daysForSubmissionAssessmentValidate =
      daysForSubmissionAssessment.length === 0
        ? "Enter No Of Days For Submission Assessment"
        : /^\d+$/.test(daysForSubmissionAssessment)
          ? ""
          : "Please enter a valid number";
    setDaysForSubmissionAssessmentError(daysForSubmissionAssessmentValidate);

    subscriptionFeeValidate =
      subscriptionFee.length === 0
        ? "Enter Subscription Fee"
        : /^\d+$/.test(subscriptionFee)
          ? ""
          : "Please enter a valid number";
    setSubscriptionFeeError(subscriptionFeeValidate);

    phoneValidate =
      phone.length === 0
        ? "Enter Phone"
        : /^(\+91[\s\-]?)?[6-9]\d{9}$/.test(phone)
          ? ""
          : "Please enter a valid number";
    setPhoneError(phoneValidate);

    //   ccMailValidate =
    //   ccMail.length === 0
    //     ? "Enter CC"
    //     : /^([\w.-]+@[\w.-]+\.[a-zA-Z]{2,})(\s*,\s*[\w.-]+@[\w.-]+\.[a-zA-Z]{2,})*$/.test(ccMail)
    //     ? ""
    //     : "Enter valid email(s), separated by commas";
    // setCcMailError(ccMailValidate);

    // bccMailValidate =
    //   bccMail.length === 0
    //     ? "Enter BCC"
    //     : /^([\w.-]+@[\w.-]+\.[a-zA-Z]{2,})(\s*,\s*[\w.-]+@[\w.-]+\.[a-zA-Z]{2,})*$/.test(bccMail)
    //     ? ""
    //     : "Enter valid email(s), separated by commas";
    // setBccMailError(bccMailValidate);

    if (
      !rowsPerPageValidate &&
      !sessionTimeValidate &&
      !emailIdValidate &&
      !passwordValidate &&
      !sizeForAttachmentValidate &&
      !totalAttachmentSizeValidate &&
      !daysForSubmissionAssessmentValidate &&
      !subscriptionFeeValidate &&
      !phoneValidate
      // &&
      // !ccMailValidate &&
      // !bccMailValidate
    ) {
      const Payload = {
        systemSettingsId: parseInt(systemSettingsId, 10),
        rowsPerPageForTables: parseInt(rowsPerPage, 10),
        emailIdForSystemGeneratedEmails: emailId,
        passwordForSystemGeneratedEmails: password,
        sessionTimeInSeconds: parseInt(sessionTime, 10),
        sizeForFileAttachment: parseInt(sizeForAttachment, 10),
        totalAttachmentFilesForAPartner: parseInt(totalAttachmentSize, 10),
        noOfDaysForSubmissionAssessment: parseInt(
          daysForSubmissionAssessment,
          10
        ),
        subscriptionFee: parseInt(subscriptionFee, 10),
        phone: phone,
        bcc: bccMail,
        cc: ccMail,
        createdBy: sessionStorage.getItem("createdBy"),
      };

      const response = await IUDAPI(
        [Payload],

        "SystemSettingsAPI/IUDSystemSettings"
      );

      if (response.data.Table[0].result === "M") {
        toast.success("System Settings added successfully 👍", {
          duration: 5000,

          position: "top-center",
        });
        Cancel();
        setTimeout(5000);
      } else {
        toast.error("Failed to add System Settings data 👎", {
          duration: 2000,

          position: "top-center",
        });
        Cancel();
        setTimeout(2000);
      }
    } else {
      setSubmitBtnDisabled(false);
    }
  };

  return (
    <MainLayout pageName={"2"}>
      <div class="container flex flex-col">
        <div class={mainTable.addScreenTitle}>
          <p class={mainTable.headerTitle}>System Settings</p>
        </div>

        <form action="" class="formCss">
          <div className="flex justify-center overflow-auto p-5 min-h-[60vh] max-h-[72vh]">
            <div className="w-3/4">
              <div class="grid gap-4 mb-4 md:grid-cols-2">
                <InputText
                  inputType="text"
                  classStar={"text-red-500"}
                  title="Rows Per Page For Tables"
                  name="rowsPerPage"
                  content={rowsPerPage}
                  maxLength={5}
                  controlFunc={(e) => setRowsPerPage(e.target.value)}
                  controlFuncBlur={(e) => {
                    const value = e.target.value.trim();

                    if (value === "") {
                      setRowsPerPageError("Enter Rows Per Page For Tables");
                    } else if (!validRows.includes(value)) {
                      setRowsPerPageError(
                        "Please enter a valid value (10, 25, 50, 100, 500, 1000, or 5000)"
                      );
                    } else {
                      setRowsPerPageError("");
                    }
                  }}
                  errorMessage={rowsPerPageError}
                />
                <InputText
                  inputType="text"
                  classStar={"text-red-500"}
                  title="Session Time in Seconds"
                  name="sessionTime"
                  maxLength={7}
                  content={sessionTime}
                  controlFunc={(e) => setSessionTime(e.target.value)}
                  controlFuncBlur={(e) => {
                    if (!/^\d+$/.test(e.target.value)) {
                      setSessionTimeError("Please enter a valid number");
                    } else {
                      setSessionTimeError("");
                    }
                  }}
                  errorMessage={sessionTimeError}
                />
              </div>

              <div class="grid gap-4 mb-4 md:grid-cols-2">
                <InputText
                  inputType={"text"}
                  title={"Email Id For System Generated Emails"}
                  name={"emailId"}
                  classStar={"text-red-500"}
                  content={emailId}
                  maxLength={200}
                  controlFunc={(e) => setEmailId(e.target.value)}
                  controlFuncBlur={(e) => {
                    const enteredEmail = e.target.value.trim(); // Trim to remove leading/trailing spaces

                    setEmailId(enteredEmail); // Update emailId state with the trimmed value

                    if (enteredEmail.length > 0) {
                      // Check if enteredEmail matches a broader email pattern

                      const isValidEmail =
                        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i.test(
                          enteredEmail
                        );

                      setEmailIdError(
                        isValidEmail ? "" : "Enter a Valid Email Id"
                      );
                    } else {
                      setEmailIdError("Enter Email");
                    }
                  }}
                  errorMessage={emailIdError}
                />

                <InputText
                  inputType="text"
                  title="Password For System Generated Emails"
                  name="password"
                  classStar={"text-red-500"}
                  maxLength={50}
                  content={password}
                  controlFunc={(e) => setPassword(e.target.value)}
                  controlFuncBlur={(e) => {
                    if (!e.target.value.trim()) {
                      setPasswordError("Enter Password");
                    } else {
                      setPasswordError("");
                    }
                  }}
                  errorMessage={passwordError}
                />

                <InputText
                  inputType="text"
                  title="Size For File Attachment (each file in MB)"
                  name="sizeForAttachment"
                  classStar={"text-red-500"}
                  maxLength={5}
                  content={sizeForAttachment}
                  controlFunc={(e) => setSizeForAttachment(e.target.value)}
                  controlFuncBlur={(e) => {
                    if (!/^\d+$/.test(e.target.value)) {
                      setSizeForAttachmentError("Please enter a valid number");
                    } else {
                      setSizeForAttachmentError("");
                    }
                  }}
                  errorMessage={sizeForAttachmentError}
                />

                <InputText
                  inputType="text"
                  title="Total File Size For All Attachment for Partner (in MB)"
                  name="totalAttachmentSize"
                  classStar={"text-red-500"}
                  maxLength={5}
                  content={totalAttachmentSize}
                  controlFunc={(e) => setTotalAttachmentSize(e.target.value)}
                  controlFuncBlur={(e) => {
                    if (!/^\d+$/.test(e.target.value)) {
                      setTotalAttachmentSizeError(
                        "Please enter a valid number"
                      );
                    } else {
                      setTotalAttachmentSizeError("");
                    }
                  }}
                  errorMessage={totalAttachmentSizeError}
                />

                <InputText
                  inputType="text"
                  title="No Of Days to Submit for Assessment"
                  name="daysForSubmissionAssessment"
                  classStar={"text-red-500"}
                  maxLength={5}
                  content={daysForSubmissionAssessment}
                  controlFunc={(e) =>
                    setDaysForSubmissionAssessment(e.target.value)
                  }
                  controlFuncBlur={(e) => {
                    if (!/^\d+$/.test(e.target.value)) {
                      setDaysForSubmissionAssessmentError(
                        "Please enter a valid number"
                      );
                    } else {
                      setDaysForSubmissionAssessmentError("");
                    }
                  }}
                  errorMessage={daysForSubmissionAssessmentError}
                />
                <InputText
                  inputType="text"
                  title="Subscription Fee (in INR)"
                  name="subscriptionFee"
                  classStar={"text-red-500"}
                  maxLength={7}
                  content={subscriptionFee}
                  controlFunc={(e) => setSubscriptionFee(e.target.value)}
                  controlFuncBlur={(e) => {
                    if (!/^\d+$/.test(e.target.value)) {
                      setSubscriptionFeeError("Enter Subscription Fee");
                    } else {
                      setSubscriptionFeeError("");
                    }
                  }}
                  errorMessage={subscriptionFeeError}
                />
                <InputText
                  inputType="text"
                  title="Phone"
                  name="phone"
                  classStar={"text-red-500"}
                  maxLength={15}
                  content={phone}
                  controlFunc={(e) => setPhone(e.target.value)}
                  controlFuncBlur={(e) => {
                    if (/^(\+91[\s\-]?)?[6-9]\d{9}$/.test(e.target.value)) {
                      setPhoneError(""); // valid → clear error
                    } else {
                      setPhoneError("Enter valid phone number"); // invalid → show error
                    }
                  }}
                  errorMessage={phoneError}
                />

                <InputText
                  inputType="text"
                  title="all mails CC to"
                  name="cc"
                  maxLength={500}
                  content={ccMail}
                  controlFunc={(e) => setCcMail(e.target.value)}
                  controlFuncBlur={(e) => {
                    const ccRegex =
                      /^([\w.-]+@[\w.-]+\.[a-zA-Z]{2,})(\s*,\s*[\w.-]+@[\w.-]+\.[a-zA-Z]{2,})*$/;
                    if (e.target.value && !ccRegex.test(e.target.value)) {
                      setCcMailError(
                        "Enter valid email(s), separated by commas"
                      );
                    } else {
                      setCcMailError("");
                    }
                  }}
                  errorMessage={ccMailError}
                />

                <InputText
                  inputType="text"
                  title="all mails BCC to"
                  name="bcc"
                  maxLength={500}
                  content={bccMail}
                  controlFunc={(e) => setBccMail(e.target.value)}
                  controlFuncBlur={(e) => {
                    const bccRegex =
                      /^([\w.-]+@[\w.-]+\.[a-zA-Z]{2,})(\s*,\s*[\w.-]+@[\w.-]+\.[a-zA-Z]{2,})*$/;
                    if (bccMail && !bccRegex.test(e.target.value)) {
                      setBccMailError(
                        "Enter valid email(s), separated by commas"
                      );
                    } else {
                      setBccMailError("");
                    }
                  }}
                  errorMessage={bccMailError}
                />
              </div>

              <Buttons
                addScreenTitle={true}
                handleSubmit={HandleSubmit}
                cancel={Cancel}
                disabledBtn={submitBtnDisabled ? true : false}
              />
            </div>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default SystemSettings;
